export default "__VITE_ASSET__Ct4_iddb__"